/* Aretina · Cart Drawer custom behaviors
 * - Upsell carousel: prev/next/dots + AJAX add (re-render via theme:cart:refresh)
 * - Variant select updates price display
 * - Shipping/rewards bar live update: patches fetch so it refreshes AFTER every
 *   cart mutation resolves (fixes the "lag by one action" bug)
 * - Quantity +/- override: changes by line KEY via /cart/change.js so increasing
 *   the quantity never spawns a duplicate line item
 */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    var n = (cents / 100);
    var s = n.toFixed(2).replace(/\.00$/, '');
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* ---------------- Bloques dinámicos del drawer (shipbar + upsell) -------
   * El shipbar y el upsell son bloques renderizados por servidor que dependen
   * del estado del carrito (totales, item_count) y de metafields de producto
   * (upsell_list). El tema, al mutar el carrito, sólo refresca sus propios
   * holders de line-items/precio; NUNCA toca estos dos. Por eso quedaban
   * congelados al estado del page-load (hitos sin marcar, upsell que no
   * aparecía/desaparecía) hasta recargar.
   *
   * Solución: pedimos la sección 'api-cart-items' (que ahora también renderiza
   * el shipbar y el upsell con el carrito actual) y reemplazamos el contenido
   * de los holders del drawer. Liquid es la única fuente de verdad. */
  var _dynTimer = null;

  function applyDynamic(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    var srcShip = box.querySelector('[data-api-shipbar]');
    var srcUp = box.querySelector('[data-api-upsell]');
    var dstShip = $('[data-aretina-shipbar-holder]');
    var dstUp = $('[data-aretina-upsell-holder]');
    if (dstShip && srcShip) dstShip.innerHTML = srcShip.innerHTML;
    /* El upsell puede venir vacío (sin productos con inventario) → el holder
       queda vacío y el carrusel desaparece al instante. */
    if (dstUp && srcUp) dstUp.innerHTML = srcUp.innerHTML;
    var upRoot = $('[data-aretina-upsell]');
    if (upRoot) initUpsell(upRoot);
    syncDiscountSlot();
  }

  /* ---------------- Badge de descuento bajo el input ----------------------
   * El theme renderiza los chips de descuento (.cart__discounts), los enlaza y
   * corre su detección de "código válido" DENTRO de [data-cart-price-holder]
   * (junto al subtotal). Ese nodo es la ÚNICA fuente de verdad y lo dejamos
   * intacto (oculto por CSS). Aquí CLONAMOS los chips en el slot que está
   * debajo del input. Clonar (no mover) hace la sincronización idempotente: el
   * price-holder nunca se vacía, así que llamar a esto varias veces (segundo
   * pase a 450ms, re-render del drawer, etc.) siempre refleja el estado real
   * sin "perder" el badge. (Moverlo lo vaciaba y el segundo pase borraba el
   * slot → el badge aparecía y se ocultaba.) */
  function syncDiscountSlot() {
    var slot = $('[data-aretina-discounts-slot]');
    if (!slot) return;
    var src = $('[data-cart-price-holder] .cart__discounts');
    if (src && src.children.length) {
      var clone = src.cloneNode(true);
      /* Neutralizamos data-discount-body en el clon para que el tema NO lo
         enlace ni lo cuente en su detección (el original oculto es la fuente). */
      var bodies = clone.querySelectorAll('[data-discount-body]');
      for (var i = 0; i < bodies.length; i++) bodies[i].removeAttribute('data-discount-body');
      slot.innerHTML = '';
      slot.appendChild(clone);
    } else {
      slot.innerHTML = '';
    }
  }

  /* Quitar descuento desde el clon del slot → click-through al botón ORIGINAL
     (theme-bound) en el price-holder, que dispara removeDiscount del tema. */
  function onDiscountRemove(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var rm = t.closest('[data-aretina-discounts-slot] [data-discount-remove]');
    if (!rm) return;
    e.preventDefault();
    var body = rm.closest('[data-discount-code]');
    var code = body && body.getAttribute('data-discount-code');
    var orig = null;
    if (code) {
      var esc = (window.CSS && CSS.escape) ? CSS.escape(code) : code.replace(/"/g, '\\"');
      orig = $('[data-cart-price-holder] [data-discount-code="' + esc + '"] [data-discount-remove]');
    }
    if (!orig) orig = $('[data-cart-price-holder] .cart__discounts [data-discount-remove]');
    if (orig) orig.click();
  }

  function cartUrl() {
    if (window.theme && theme.routes && theme.routes.cart_url) return theme.routes.cart_url;
    return cartRoot() + 'cart';
  }

  function fetchDynamic() {
    return fetch(cartUrl() + '?section_id=api-cart-items', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(applyDynamic)
      .catch(function () {});
  }

  /* Coalescemos ráfagas de eventos en un solo fetch, y hacemos una segunda
     pasada ~450ms después para ganarle a un renderCartDrawer tardío del tema
     (que clona el <template> y dejaría el holder con el estado del page-load). */
  function scheduleDynamic() {
    if (!$('[data-aretina-shipbar-holder]') && !$('[data-aretina-upsell-holder]')) return;
    if (_dynTimer) clearTimeout(_dynTimer);
    _dynTimer = setTimeout(function () {
      fetchDynamic();
      setTimeout(fetchDynamic, 450);
    }, 120);
  }

  /* ---------------- Contador de items del header --------------------------
   * El header NO se re-renderiza por servidor al mutar el carrito; sólo el
   * theme togglea la clase .cart__toggle--has-items pero nunca escribe un
   * número. Pedimos /cart.js (fuente de verdad del item_count) y actualizamos
   * todos los badges [data-cart-count]. */
  function updateHeaderCount() {
    return fetch(cartRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = (cart && cart.item_count) || 0;
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = n;
          if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
        });
      })
      .catch(function () {});
  }

  /* Patch fetch para refrescar los bloques dinámicos justo DESPUÉS de que
     cualquier mutación del carrito (add / change / update / clear) se confirme,
     incluso cuando la dispara el propio tema y no emite un evento custom. */
  function patchFetch() {
    if (window.__aretinaCartFetchPatched) return;
    var orig = window.fetch;
    if (typeof orig !== 'function') return;
    window.__aretinaCartFetchPatched = true;
    var MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
    window.fetch = function (input) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var p = orig.apply(this, arguments);
      if (url && MUT.test(url) && p && typeof p.then === 'function') {
        p.then(function () { scheduleDynamic(); updateHeaderCount(); }).catch(function () {});
      }
      return p;
    };
  }

  /* ---------------- Quantity +/- override (no duplicate line) ---------- */
  function changeQtyByKey(key, qty) {
    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function onQtyClickCapture(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-quantity-plus],[data-quantity-minus]');
    if (!btn) return;
    if (!btn.closest('#cart-drawer, .cart-drawer')) return; // solo dentro del drawer

    /* Tomamos el control de TODO botón +/- dentro del drawer: bloqueamos el
       handler nativo del tema SIEMPRE (antes de cualquier early-return) para
       que nunca corra en paralelo y genere una línea duplicada. */
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.disabled || btn.classList.contains('is-disabled')) return;

    var counter = btn.closest('quantity-counter, [data-quantity-holder]');
    var field = counter && counter.querySelector('[data-quantity-field]');
    var key = field && field.getAttribute('data-id');
    if (!key) return;

    var cur = parseInt(field.value, 10);
    if (isNaN(cur)) cur = parseInt(field.getAttribute('value'), 10) || 1;
    var max = parseInt(field.getAttribute('data-quantity-max'), 10);
    var isPlus = btn.matches('[data-quantity-plus]');
    var next = isPlus ? cur + 1 : cur - 1;
    if (!isNaN(max) && max > 0 && next > max) next = max;
    if (next < 0) next = 0;
    if (next === cur) return;

    field.value = next; // feedback inmediato
    var item = btn.closest('[data-cart-item]');
    if (item) item.classList.add(next === 0 ? 'is-removed' : 'is-loading');

    changeQtyByKey(key, next)
      .then(function () {
        // El tema re-renderiza el drawer (items, precio, contador) al escuchar esto
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        if (item) item.classList.remove('is-loading', 'is-removed');
      });
  }

  /* ---------------- Upsell carousel ---------------- */
  function initUpsell(root) {
    if (!root || root.__aretinaUpsellInit) return;
    var slides = $$('[data-upsell-slide]', root);
    if (!slides.length) return;
    root.__aretinaUpsellInit = true;

    var dots = $$('[data-upsell-dot]', root);
    var prev = $('[data-upsell-prev]', root);
    var next = $('[data-upsell-next]', root);
    var current = 0;
    var viewport = $('[data-upsell-viewport]', root);

    /* Carrusel = scroll horizontal nativo con scroll-snap (ver cart-drawer-overrides.css).
       El dedo ARRASTRA las cards con inercia y snap = slide real, no cambio brusco.
       Mostramos todas las cards en la fila scrolleable (quitamos el modelo viejo de
       ocultar/mostrar); flechas y dots hacen scroll suave a la card destino. */
    slides.forEach(function (s) { s.removeAttribute('hidden'); s.classList.remove('is-hidden'); });

    function setActive(i) {
      if (i < 0) i = 0; else if (i >= slides.length) i = slides.length - 1;
      current = i;
      dots.forEach(function (d, idx) {
        if (idx === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }

    function goTo(i) {
      if (i < 0) i = 0; else if (i >= slides.length) i = slides.length - 1;
      // inline:'start' desplaza SOLO en horizontal; block:'nearest' evita mover el scroll vertical del drawer.
      if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      setActive(i);
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { goTo(idx); });
    });

    /* Al deslizar con el dedo (scroll nativo) sincronizamos los dots con la card visible. */
    if (viewport) {
      var scrollTimer = null;
      viewport.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var step = slides.length > 1 ? (slides[1].offsetLeft - slides[0].offsetLeft) : viewport.clientWidth;
          if (step > 0) setActive(Math.round(viewport.scrollLeft / step));
        }, 60);
      }, { passive: true });
    }

    setActive(0);
    if (viewport) viewport.scrollLeft = 0;

    /* Variant select → live price update */
    slides.forEach(function (slide) {
      var sel = $('[data-upsell-variant]', slide);
      var priceEl = $('[data-upsell-price]', slide);
      var compareEl = $('[data-upsell-compare]', slide);
      if (!sel || !priceEl) return;
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return; // select sin opciones (sin variantes disponibles)
        var price = parseInt(opt.getAttribute('data-price') || '0', 10);
        var compare = parseInt(opt.getAttribute('data-compare') || '0', 10);
        priceEl.textContent = money(price);
        if (compareEl) {
          if (compare > price) {
            compareEl.textContent = money(compare);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      });
    });

    /* AJAX add-to-cart */
    slides.forEach(function (slide) {
      var form = $('[data-upsell-form]', slide);
      var btn = $('[data-upsell-add]', slide);
      if (!form || !btn) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = 'Agregando…';
        var fd = new FormData(form);
        fetch(cartRoot() + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Agregado';
            /* El tema re-renderiza el drawer al escuchar theme:cart:refresh */
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1200);
          })
          .catch(function () {
            btn.textContent = 'Error';
            setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1500);
          });
      });
    });
  }

  /* ---------------- Wiring ---------------- */
  function init() {
    var upsellRoot = $('[data-aretina-upsell]');
    if (upsellRoot) initUpsell(upsellRoot);
    /* Clona el badge de descuento ya presente (carrito con código al abrir). */
    syncDiscountSlot();
    /* Re-render shipbar + upsell desde servidor con el carrito actual. */
    scheduleDynamic();
    /* Sincroniza el badge del header por si el carrito cambió en otra pestaña. */
    updateHeaderCount();
  }

  /* Patch fetch ASAP (the IIFE runs deferred, before the theme fires its calls) */
  patchFetch();
  /* Quantity override: capture phase so it runs before the theme's own handler */
  document.addEventListener('click', onQtyClickCapture, true);
  /* Quitar descuento desde el clon del slot (delegado) */
  document.addEventListener('click', onDiscountRemove);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init upsell after the drawer (re)opens / re-renders. initUpsell is
     idempotent (guards against double-binding the persistent carousel). */
  ['cart:refresh', 'cart:rerender', 'cart:updated', 'cart:update', 'cart:change',
   'theme:cart:refresh', 'theme:cart:update', 'cart:open', 'theme:cart:open',
   'theme:cart:loaded'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(init, 80); });
  });
  /* Tras un re-render del drawer, vuelve a clonar el badge cuanto antes (el
     init con 80ms cubre el grueso; este tick extra reduce el parpadeo). */
  document.addEventListener('theme:cart:loaded', function () { setTimeout(syncDiscountSlot, 0); });
})();
